export default "__VITE_ASSET__Btm9ZP5y__"